import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { OrderType } from 'config/Api.Config';
import { usePricingDistributionTemplateProvider } from '../PricingDistributionTemplate.Hooks';
import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';

export default function PricingDistributionTemplateFilters() {
  const { lang } = getLocales();
  const { listApi } = usePricingDistributionTemplateProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      filters={listApi?.body}
      onFilter={(newFilers) => listApi?.execute({ ...newFilers, offset: 0 })}
      onReset={listApi?.reset}
      headerActions={
        <DropdownButton
          buttonMedia={<Icon class="fas-sort" />}
          horizontalPosition="auto_fixed"
          verticalPosition="auto_fixed"
          htmlElementProps={{ title: lang.sort }}
          subcomponents={ThemeDropdownButtonPopup}
          dropdownOptions={
            <>
              <Button
                class={ThemeButtonMenuItem}
                render={lang.newerFirst}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: undefined,
                  orderType: undefined,
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.olderFirst}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'id',
                  orderType: OrderType.asc,
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.ascendingByName}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'Name',
                  orderType: OrderType.asc,
                  thenBy: ['Name'],
                  thenType: [OrderType.asc, OrderType.asc, OrderType.asc],
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.descendingByName}
                media={<Icon class="fas-caret-down" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'Name',
                  orderType: OrderType.desc,
                  thenBy: ['Name'],
                  thenType: [OrderType.desc, OrderType.desc, OrderType.desc],
                })}
              />
            </>
          }
        />
      }
    />
  );
}
